import { SVG, SVGProps } from './svg'

export function IconCaretRight(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M11 16h-1V8a1 1 0 011 0l4 4-4 4z" />
    </SVG>
  )
}
